// components/chakra/NavbarWithCallToAction/NavbarWithCallToAction.tsx

import {
  Box,
  Button,
  Container,
  Flex,
  HStack,
  IconButton,
  Link,
  Stack,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { Logo } from "../../Logo";

import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import { CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import { SecureMembershipButton } from "../../SecureMembershipButton";
import { LoginWithSmsModal } from "../../LoginWithSmsModal";
import { getColor } from "../../../brandConfig";

const Links = [

  // { name: 'Business Services', path: '/business-services' },
  // { name: 'Programs', path: '/programs' },
  // { name: "About", path: "/founders" },
  // { name: "Services", path: "/services" },
  // { name: "Intro Session", path: "/intro-session" },
  { name: "Governance", path: "/governance" },
  // { name: "Contact", path: "/founders" },
];

export const NavbarWithCallToAction = () => {
  const isDesktop = useBreakpointValue({ base: false, "3xl": true });
  const { isOpen, onToggle } = useDisclosure();
  const { isOpen: isLoginOpen, onOpen: onLoginOpen, onClose: onLoginClose } = useDisclosure();
  const navigate = useNavigate();
  const { isAuthenticated, user, logout, refreshAuth } = useAuth();

  const handleAuthAction = async () => {
    if (isAuthenticated) {
      await logout();
      navigate("/");
    } else {
      onLoginOpen(); // Open login modal instead of navigating
    }
  };

  const handleLoginSuccess = () => {
    onLoginClose();
    refreshAuth(); // Refresh auth context after successful login
  };

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <Box 
      position="sticky" 
      top={0} 
      zIndex="sticky"
      bg={getColor("background.main")}
      borderBottom="1px solid"
      borderColor={getColor("border.medium")}
      boxShadow={`0 2px 10px ${getColor("border.light")}`}
    >
      <Container maxW="7xl">
        <Flex
          minH={"60px"}
          py={{ base: 2 }}
          align={"center"}
          justify={"space-between"}
        >
          <Link onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <Logo />
          </Link>
          
          <HStack spacing={8} display={{ base: "none", md: "flex" }}>
            {Links.map((link) => (
              <Link
                key={link.name}
                px={2}
                py={1}
                rounded={"md"}
                color={getColor("primary")}
                _hover={{
                  textDecoration: "none",
                  color: getColor("secondary"),
                  bg: getColor("background.overlay"),
                }}
                href={link.path}
              >
                {link.name}
              </Link>
            ))}
          </HStack>

          <HStack spacing={4}>
            {isAuthenticated ? (
              <Button
                onClick={handleAuthAction}
                size="sm"
                px={6}
                sx={{
                  background: getColor("primary"),
                  color: getColor("text.inverse"),
                  boxShadow: `0 4px 20px ${getColor("border.medium")}`,
                  transition: "all 0.2s ease-in-out",
                  _hover: {
                    transform: "translateY(-2px)",
                    boxShadow: `0 6px 25px ${getColor("border.dark")}`,
                    background: getColor("secondary"),
                  }
                }}
              >
                Logout
              </Button>
            ) : (
              <SecureMembershipButton />
            )}
            
            <IconButton
              display={{ base: "flex", md: "none" }}
              onClick={onToggle}
              icon={isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />}
              variant={"ghost"}
              color={getColor("primary")}
              aria-label={"Toggle Navigation"}
              _hover={{
                color: getColor("secondary"),
                bg: getColor("background.overlay"),
              }}
            />
          </HStack>
        </Flex>

        {/* Mobile menu */}
        <Stack
          display={{ base: isOpen ? "flex" : "none", md: "none" }}
          p={4}
          bg={getColor("background.main")}
        >
          {Links.map((link) => (
            <Link
              key={link.name}
              px={2}
              py={1}
              rounded={"md"}
              color={getColor("primary")}
              _hover={{
                textDecoration: "none",
                color: getColor("secondary"),
                bg: getColor("background.overlay"),
              }}
              href={link.path}
            >
              {link.name}
            </Link>
          ))}
        </Stack>
      </Container>

      {/* SMS Login Modal */}
      <LoginWithSmsModal
        isOpen={isLoginOpen}
        onClose={onLoginClose}
        onLoginSuccess={handleLoginSuccess}
      />
    </Box>
  );
};